import { z } from 'zod'
import { useContext } from 'react'

import { AnalyticsEvent, RoutesPath } from 'src/types'

import { useNavigation } from 'src/hooks/useNavigation'
import { useAppDispatch } from 'src/hooks/useAppDispatch'
import { AnalyticsContext } from 'src/contexts/AnalyticsContext'

import { signIn, signInWithGoogle, signUp } from 'src/store/thunks/authThunk'
import { formSchema } from 'src/pages/Login/constnants'
import extendedSchema from 'src/helpers/validations/signup'

import { hidePostRegiPopup } from 'src/store/reducers/AuthReducer/AuthSlice'

export const useAuthLayout = () => {
  const dispatch = useAppDispatch()
  const { logEvent } = useContext(AnalyticsContext)
  const { navigateTo } = useNavigation()

  const handleSignInWithGoogle = (): void => {
    dispatch(signInWithGoogle(navigateTo))
    logEvent(AnalyticsEvent.LOGIN, { with: 'google' })
  }

  const onSubmitSignupForm = (data: z.infer<typeof extendedSchema>): void => {
    dispatch(signUp(data.email, data.password))
    logEvent(AnalyticsEvent.SIGNUP)
  }

  const onLogin = (data: z.infer<typeof formSchema>): void => {
    dispatch(signIn(data.email, data.password, navigateTo))
    logEvent(AnalyticsEvent.LOGIN, { with: 'mail' })
  }

  const handleFillAutoRoute = () => {
    dispatch(hidePostRegiPopup())
    navigateTo(RoutesPath.FILL_AUTO_INFO)
  }

  const handleClose = () => {
    dispatch(hidePostRegiPopup())
  }

  const handleHome = () => {
    handleClose()
    navigateTo(RoutesPath.HOME)
  }

  return {
    handleSignInWithGoogle,
    onSubmitSignupForm,
    onLogin,
    handleFillAutoRoute,
    handleClose,
    handleHome,
  }
}
